<template>
	<div class="stage stage--teamrole" :style="{ 'background-image': backgroundImage }">

	 	<div class="multiquiz__background-overlay background-overlay">

			<div class="content-container">

		        <div class="flex flexColumn" style="height: 100%;">	
		        	<div class="flexHeaderContainer">
		        		<div class="header__container">
	                        <div class="header">
	                            {{questionData.header}}
	                        </div>
	                        <div class="subHeader">
	                            {{questionData.subheader}}
	                        </div>
	                        <div class="text">{{questionData.questiontext}}</div>
	                    </div>
		        	</div>
		    		
		        	<div v-if="questionData != null" class="buttonQuizContent">
		                <div class="image-box">
		                    <div class="shadow-box centered">
		                        <img :src="baseUrl + questionData.visual"/>
		                    </div>
		                </div>
		        	</div>
					<div v-if="questionData != null" class="button-conainer">
						<AnswerButton v-for="(answer , index) in questionData.answers" :key="index" :title="answer.title" :text="answer.answer_text" :visual="baseUrl + answer.visual" :on-click="() => {onQuestionAnswer(index)}"/>
					</div>
		        </div>

		    </div>
		    
	    </div>













		

		
	</div>
</template>

<script>
	import Score from '../../Score.vue';
	import Button from './Button.vue';
	import { url} from '../../../const/base';
	import { mapGetters , mapActions } from 'vuex';

	export default {

		components:{
			Score,
			AnswerButton : Button,
		},

		data(){
			return{
				baseUrl : url,
				score: 0,
				answers: [],
			}
		},

		mounted(){
			this.score = 0;
			this.showTransitorScore(true);
		},

		computed: {

			backgroundImage: function() {
		        return 'url('+ this.baseUrl + this.roundData.questions.question_background + ')';
		    },

			...mapGetters([
				"lastQuestion",
				"questionData",
				"roundData",
				"questionCount"
			]),

		},


		methods:{

			...mapActions([
				"completeRound",
				"toNextQuestion",
				"setRoundScore",
				"logAnswers",
				"increaseTransitorScore",
				"showTransitorScore",
				"setFeedbackData",
				"setUserRole",
			]),


			onQuestionAnswer(e){
				this.answers.push(e);
				
				if(this.lastQuestion){
					this.setRoundScore((this.score / this.questionCount)*100).then(()=>{
						this.logAnswers(this.answers).then(()=> {
							this.setFeedbackData({
									answer: e
								}).then(()=>{
									this.completeRound().then(()=> {
										this.setUserRole(e);
									});
								});
							
						});
					});
				}
				else{
					this.toNextQuestion();
				}
			}
		}

	}
</script>





// WEBPACK FOOTER //
// src/components/minigames/teamrole/Index.vue